import React, { useState } from "react";
import { Button, Modal, Form, Input, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const EditProfile = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const handleEditClick = () => {
    navigate("/dashboard/editadminprofile", { state: { user: user.user } });
  };

  return (
    <div className="w-full bg-slate-200 p-6 pb-20 rounded-lg shadow-md">
      <div className="bg-white rounded-lg p-4">
        <div className="flex justify-between">
          <h1 className="text-xl font-semibold mb-4">My Profile</h1>
        </div>
        <div className="bg-gray-200 p-5 rounded-lg">
          <div className="bg-white rounded-lg flex gap-8 px-20 py-8">
            <img
              src={user.profile_picture_url}
              className="h-28 w-28 rounded-full"
              alt="profile"
            />
            <div className="my-auto">
              <p className="text-lg font-semibold">{user.user.name}</p>
              <p className="text-md">{user.role}</p>
              <p className="text-md">{user.user.address}</p>
            </div>
          </div>
          <div className="flex justify-between mt-8 mb-4">
            <h1 className="text-xl font-semibold">Personal Information</h1>
            <Button
              type="default"
              className="bg-green-800 text-white hover:bg-green-600"
              icon={<EditOutlined />}
              onClick={handleEditClick}
            >
              Edit
            </Button>
          </div>
          <div className="bg-white p-4 rounded-lg px-20 py-8">
            <div className="flex justify-between">
              <div>
                <p className="text-gray-500">Name</p>
                <p className="font-semibold mt-2">{user.user.name}</p>
              </div>
              <div>
                <p className="text-gray-500">Email</p>
                <p className="font-semibold mt-2">{user.user.email}</p>
              </div>
              <div>
                <p className="text-gray-500">Phone Number</p>
                <p className="font-semibold mt-2">{user.user.phone_number}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
